import { TableCell, TableRow, tableCellClasses, Toolbar, OutlinedInput } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateRange } from 'react-date-range';

export const StyledTableRow = styled(TableRow)(() => ({
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: 'rgba(2, 132, 199, 0.03) !important'
  },
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: 'rgba(2, 132, 199, 0.06) !important'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 11.5,
    fontWeight: 700,
    padding: '12px 14px',
    backgroundColor: '#ffffff',
    color: '#64748b',
    borderBottom: '1px solid #e2e8f0',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 14px',
    color: '#334155',
    borderBottom: '1px solid #f1f5f9'
  }
}));

export const RootStyle = styled(Toolbar)(() => ({
  minHeight: 56,
  padding: '8px 16px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  flexWrap: 'wrap'
}));

export const SearchStyle = styled(OutlinedInput)(() => ({
  width: 280,
  height: 40,
  backgroundColor: '#ffffff',
  borderRadius: 10,
  fontSize: '13px',
  transition: 'all 0.2s ease',
  '& fieldset': {
    borderColor: '#e2e8f0 !important'
  },
  '&:hover fieldset': {
    borderColor: '#cbd5e1 !important'
  },
  '&.Mui-focused fieldset': {
    borderColor: '#0284c7 !important',
    borderWidth: '1.5px !important'
  }
}));

export const pillTabsSx = {
  minHeight: 'auto',
  '& .MuiTabs-indicator': {
    display: 'none'
  },
  '& .MuiTabs-flexContainer': {
    flexWrap: 'wrap',
    gap: 1.25,
    p: '2px 2px 6px'
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    minWidth: 120,
    minHeight: 40,
    py: 0,
    px: 2.5,
    borderRadius: '999px',
    border: '1px solid #cbd5e1',
    backgroundColor: '#fff',
    color: '#475569',
    transition: 'all 0.2s ease',
    '& .MuiTab-iconWrapper': {
      fontSize: 18,
      mr: 1
    },
    '&:hover': {
      borderColor: '#13519d',
      color: '#13519d',
      backgroundColor: '#f0f5fb'
    },
    '&.Mui-selected': {
      color: '#fff',
      fontWeight: 700,
      borderColor: '#13519d',
      backgroundColor: '#13519d',
      boxShadow: '0 3px 8px rgba(19, 81, 157, 0.25)'
    },
    '&.Mui-disabled': {
      color: '#94a3b8',
      borderColor: '#e2e8f0',
      backgroundColor: '#f8fafc'
    }
  }
};

export const pillTabButtonSx = (active) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  flexShrink: 0,
  minWidth: 120,
  minHeight: 40,
  py: 0,
  px: 2.5,
  borderRadius: '999px',
  border: '1px solid',
  borderColor: active ? '#13519d' : '#cbd5e1',
  bgcolor: active ? '#13519d' : '#fff',
  color: active ? '#fff' : '#475569',
  fontFamily: 'inherit',
  fontSize: 14,
  fontWeight: active ? 700 : 600,
  lineHeight: 1.25,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  boxShadow: active ? '0 3px 8px rgba(19, 81, 157, 0.25)' : 'none',
  transition: 'all 0.2s ease',
  '& .MuiSvgIcon-root': {
    fontSize: 18
  },
  '& .MuiButton-startIcon': {
    m: 0,
    '& > .MuiSvgIcon-root': {
      fontSize: 18
    }
  },
  '&:hover': {
    borderColor: '#13519d',
    color: active ? '#fff' : '#13519d',
    bgcolor: active ? '#13519d' : '#f0f5fb'
  }
});

export const DateRangeStyled = styled(DateRange)(() => ({
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  borderRadius: '12px',
  boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
  border: '1px solid #e2e8f0',
  backgroundColor: '#ffffff',
  zIndex: 100,
  overflow: 'hidden'
}));
